import React from 'react'
import { useParams } from 'react-router-dom'
import ApiService from "../../services/ApiService";
import Utils from "../../services/Utils";
import { Spinner } from "react-bootstrap";
export default function DownloadPdf() {
  const [loader, setLoader] = React.useState(false);
  const [responsePdf, setResponsePdf] = React.useState(false);
  const routeParams = useParams();


  /**
     * Cette fonction télécharge le fichier Zip contenant les Pdf pour une marque et une année données.
     * @param { pdfName } le nom du pdf est reçu à travels le lien du mail 
     */

  const DownloadPdf = () => {
    setLoader(true)
    ApiService.requestBlobFile(
      {},
      `download-pdf/${routeParams.pdfName}`,
      "get"
    )
      .then(function (response) {
        setLoader(false)
        setResponsePdf(true)
        // console.log(response, "response")
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute('download', `${routeParams.pdfName}`);
        document.body.appendChild(link);
        link.click();
        Utils.notifySuccess("Rapport Pdf téléchargé");
      })
      .catch(function (error) {
        setLoader(false)
        setResponsePdf(false)
        console.log(error);
        if (error.response.status === 404) {
          return
        }
        Utils.notifyError("du téléchargement du fichier zip" + " " + routeParams.pdfName);

      });
  };

  React.useEffect(() => {
    DownloadPdf()
  }, [])
  return (
    <>{!loader ?
      <div> {responsePdf ? "Téléchargement du fichier: " + routeParams.pdfName : 'Le lien a expiré ou le Fichier ' + routeParams.pdfName + "a déjà été téléchargé."}  </div> :
      <div className="text-center pt-5">
        <Spinner
          animation={loader ? "border" : false}
          role="status"
        ></Spinner>
      </div>
    }
    </>

  )
}
